import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { UserService } from '../../../providers/user.service';
import { UserCreateComponent } from '../user-create/user-create.component';

@Component({
  selector: 'app-tdlte-create',
  templateUrl: '../../shared/base-form/base-form.component.html',
  styleUrls: ['./tdlte-create.component.scss']
})
export class TdlteCreateComponent extends UserCreateComponent implements OnInit {
  simCards: any;
  constructor(
    public cookieService: CookieService,
    public activeModal: NgbActiveModal,
    public titleService: Title,
    public translator: TranslateService,
    public service: UserService,
  ) {
    super(cookieService, activeModal, titleService, translator, service);
    this.subentityName = 'tdlte';

  }

  getMeta(): Promise<any> {
    return new Promise(async (resolve, reject) => {
      const meta = await super.getMeta();
      if (!this.isEdit) {
        this.service.getAvailableSims().subscribe((result: any) => {
          this.simCards = result.map((data) => {
            console.log(data)
            return { value: data.imsi, name: `${data.id} (${data.is_fd ? 'FD' : 'TD'} ${data.vendor})`, msisdn: data.msisdn };
          });
          meta.fields = meta.fields.filter(f => f.name !== 'username');
          meta.fields.unshift({
            name: 'serial_no',
            caption: this.translator.instant('SERIAL_NO'),
            type: {
              name: 'select',
              options: this.simCards,
            },
            rules: [{ type: 'required' }]
          });
          resolve(meta);
        });
      } else {
        resolve(meta);
      }
    });
  }


  getBody(): any {
    if (this.isEdit) {
      return super.getBody();
    } else {
      const selectedSerial = this.formData['serial_no'];
      const msisdn = this.simCards.filter(item => item.value === selectedSerial)[0].msisdn;
      return {
        username: msisdn,
        service_type: this.subentityName
      };
    }
  }

  save(body, apply) {
    if (!this.isEdit) {
      body.username = this.simCards.filter(item => item.value === this.formData['serial_no'])[0].msisdn;
    }
    super.save(body, apply);
  }

}
